import {
	blackColors,
	blackColor,
	whiteColor,
	defaultBodyFont,
	primaryColor,
	dark_grey_1,
	blue_1,
	grayColor,
} from 'assets/jss/material-dashboard-pro-react';

const billsStyle = (theme) => ({
	wrapper: {
		width: '100%',
		'& .rt-td': {
			display: 'flex',
			'& > *': {
				marginTop: 'auto',
				marginBottom: 'auto',
			},
		},
		'& .ReactTable': {
			marginBottom: '70px',
		},
	},
	datePicker: {
		width: 'calc(50% - 4px)',
		display: 'inline-block',
		'&:first-child': {
			marginRight: 4,
		},
		'&:nth-child(2)': {
			marginLeft: 4,
		},
		'& .MuiFormControl-root': {
			marginBottom: 8,
		},
	},
	document: {
		margin: '0 auto',
		width: '100%',
		'& img': {
			display: 'block',
			margin: '0 auto',
			cursor: 'pointer',
		},
	},
	paymentAmountTabWrapper: {
		maxWidth: 424,
		margin: '38px auto 24px',
		display: 'flex',
		[theme.breakpoints.down('xs')]: {
			flexDirection: 'column',
			padding: '0 30px',
		},
	},
	currentAmount: {
		marginBottom: 25,
	},
	iconWrapper: {
		textAlign: 'left',
		[theme.breakpoints.up('sm')]: {
			marginRight: 8,
		},
		'& > svg': {
			width: 64,
			height: 'auto',
			color: blackColors[5],
		},
	},
	payBalanceBodyWrapper: {
		marginTop: 30,
	},
	paySelectedBodyWrapper: {
		paddingLeft: 50,
		paddingRight: 50,
		paddingTop: 10,
		paddingBottom: 10,
	},
	paySelectedSummary: {
		display: 'flex',
		justifyContent: 'space-between',
		padding: 20,
	},
	paymentSelectedWrapper: {
		width: 624,
		maxWidth: '100%',
	},
	paymentSelectedContentWrapper: {
		backgroundColor: whiteColor,
		padding: 32,
		borderRadius: 8,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	paymentSelectedFooter: {
		display: 'flex',
		justifyContent: 'flex-end',
		paddingTop: 72,
		width: '100%',
		'& button': {
			marginTop: 0,
			marginBottom: 0,
			width: 150,
		},
	},
	totalDueTooltipWrapper: {
		display: 'inline-block',
		'& > svg': {
			marginLeft: 8,
		},
	},
	totalDueCell: {
		display: 'flex',
		justifyContent: 'center',
	},
	dateRangeInfoWrapper: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		'& svg': {
			marginRight: 4,
			width: 20,
		},
		'white-space': 'pre-wrap',
	},
	paymentStatusWrapper: {
		margin: '0 auto',
	},
	tableAdditionalElement: {
		position: 'absolute',
		top: '4px',
		left: '200px',
		width: '10%',
		'& > div': {
			marginTop: '6px',
		},
	},
	additionalSelectText: {
		paddingLeft: '8px',
	},
	numberSearchWrapper: {
		marginBottom: '16px',
		'& > div > div > div': {
			backgroundColor: whiteColor,
			padding: '8px',
		},
		'& svg': {
			top: '31px',
		},
	},
	iconDownloadWrapper: {
		padding: '0 8px',
		'& .textRight': {
			marginRight: '10px',
		},
		'& .textLeft': {
			marginLeft: '5px',
		},
		'& .MuiCircularProgress-indeterminate': {
			animation: 'none',
		},
		'& .loader': {
			marginTop: '4px',
		},
	},
	failWrapper: {
		padding: '0 8px',
		pointerEvents: 'none',
		cursor: 'no-drop',
		'& .textRight': {
			marginRight: '10px',
		},
		'& .textLeft': {
			marginLeft: '5px',
		},
		'& .MuiCircularProgress-indeterminate': {
			animation: 'none',
		},
		'& .loader': {
			marginTop: '4px',
		},
	},
	flexWrapper: {
		display: 'flex',
		justifyContent: 'end',
		[theme.breakpoints.down('md')]: {
			'& button': {
				width: '100%',
			},
		},
		'& button.fontButton': {
			color: blackColor,
			...defaultBodyFont,
			'& svg': {
				color: primaryColor[0],
			},
		},
	},
	tooltipWrapper: {
		display: 'inline-block',
		'& > svg': {
			marginLeft: 8,
			marginTop: 9,
		},
	},
	billingAccountBadges: {
		display: 'flex',
		flexWrap: 'wrap',
	},
	clearAll: {
		marginTop: '20px',
		color: `${primaryColor[0]} !important`,
		cursor: 'pointer',
	},
	headerWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
	},
	downloadButton: {
		background: whiteColor,
	},
	filtersWrapper: {
		display: 'flex',
	},

	alternativeSelectWrapper: {
		marginRight: '50px',
		flex: '1 1 0',
	},
	selectedItem: {},
	cell: {
		width: '28px',
		margin: 'auto',
		padding: '8px 0 6px',
	},
	formControl: {
		paddingTop: 0,
	},
	filterTags: {
		padding: '8px',
		borderRadius: '70px',
		'& p': {
			marginRight: '20px',
		},
	},
	filterTagsWrapper: {
		display: 'flex',
		gap: '16px',
		flexWrap: 'wrap',
	},
	payButton: {
		background: primaryColor[0],
		color: whiteColor,
		height: '40px',
		borderRadius: '4px',
		padding: '0px 51px',
	},
	payBill: {
		boxShadow: '0 0 24px 0',
		background: 'white',
		width: '100%',
		'& .MuiButton-root:hover, .MuiButton-root:focus': {
			background: `${blue_1} !important`,
			color: `${whiteColor} !important`,
		},
		'& .Mui-disabled': {
			backgroundColor: dark_grey_1,
			color: whiteColor,
		},
	},
	amountSection: {
		background: grayColor[16],
		borderRight: `1px solid ${grayColor[0]}`,
		padding: '24px',
	},
	blueText: {
		color: `${primaryColor[0]} !important`,
	},
	selectedBillsCount: {
		padding: '24px',
	},
	payButtonWrapper: {
		marginLeft: '20px',
	},
	[theme.breakpoints.up('sm')]: {
		payBill: ({ isNewHeaderVisible }) => ({
			boxShadow: '0 0 24px 0',
			display: 'grid',
			gridTemplateColumns: '300px 250px auto',
			position: 'absolute',
			left: isNewHeaderVisible ? 'auto' : 0,
			height: 'fit-content',
			zIndex: 2,
			alignItems: 'center',
			background: 'white',
			bottom: isNewHeaderVisible ? '-24px' : '140px',
			width: isNewHeaderVisible ? 'calc(100% - 24px)' : '100%',
		}),
		amountSection: {
			padding: '24px 24px 24px 42px',
		},
		selectedBillsCount: {
			padding: 0,
			paddingLeft: '24px',
		},
		payButtonWrapper: {
			marginRight: '40px',
			'& button': {
				float: 'right',
			},
		},
	},

	[theme.breakpoints.up('md')]: {
		payBill: ({ isNewHeaderVisible }) => ({
			gridTemplateColumns: '300px 250px auto',
			bottom: isNewHeaderVisible ? '-24px' : '106px',
		}),
	},
	clearTag: {
		width: '10%',
	},
	pdfHeader: {
		position: 'absolute',
		top: '38%',
		left: '40%',
	},
	accountNumberWarningMsg: {
		color: `${primaryColor[0]} !important`,
	},
});

export default billsStyle;
